import { AbstractPmsApiService } from "./abstract.service";
import { Currency } from "../models";

/**
 * @class CurrencyPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Currency>}
 */
export class CurrencyPmsApiService extends AbstractPmsApiService {

    /**
     * @returns {String}
     */
    get urlPattern() {
        
        return '/currency(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Currency}
     * @protected
     */
    newModel(attributes) {
        
        return new Currency(attributes);
    }
    
    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<Currency>>}
     */
    get (params = {}) {
        
        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Currency} currency
     * @returns {Promise.<Currency>}
     */
    create(currency) {

        const url = this.url();

        return this.http
                   .post(url, currency, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {Currency} currency
     * @returns {Promise.<Currency>}
     */
    update(currency) {

        const url = this.url({id: currency.id});

        return this.http
                   .put(url, currency, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {Currency} currency
     * @returns {Promise.<boolean>}
     */
    delete(currency) {

        const url = this.url({id: currency.id});

        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/currency.service.js